import React from 'react';
import * as PropTypes from 'prop-types';
import Checkbox from '../../Checkbox';

const propTypes = {
  name: PropTypes.string.isRequired,
  schoolBid: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

function SchoolCheckItem({ name, schoolBid, isChecked, onChange, disabled }) {
  return (
    <li>
      <Checkbox
        label={name}
        ariaLabel={name}
        checked={isChecked}
        onChange={() => onChange(schoolBid, !isChecked)}
        disabled={disabled}
      />
    </li>
  );
}

SchoolCheckItem.propTypes = propTypes;

export default SchoolCheckItem;
